/**
 * @author caijianjia
 * @date 2020/3/19 6:16 下午
 */
export const familyData = [
    {key: 'Arial', value: 'Arial'},
    {key: 'Microsoft YaHei', value: '微软雅黑'},
    {key: 'SimHei', value: '黑体'},
    {key: 'SimSun', value: '宋体'},
    {key: 'KaiTi, 楷体', value: '楷体'},
    {key: 'LiSu, 隶书', value: '隶书'},
    {key: 'STCaiyun, 华文彩云', value: '华文彩云'},
    {key: 'STXinwei, 华文新魏', value: '华文新魏'},
    {key: 'Verdana', value: 'Verdana'},
    {key: 'Times New Roman', value: 'Times New Roman'},
    {key: 'Helvetica', value: 'Helvetica'},
    {key: 'Garamond', value: 'Garamond'},
    {key: 'Frutiger', value: 'Frutiger'},
    {key: 'Bodoni', value: 'Bodoni'},
]
export const fontSizeData = [
    {key: '12', value: '12号'},
    {key: '14', value: '14号'},
    {key: '16', value: '16号'},
    {key: '18', value: '18号'},
    {key: '20', value: '20号'},
    {key: '22', value: '22号'},
    {key: '24', value: '24号'},
    {key: '30', value: '30号'},
    {key: '48', value: '48号'},
    {key: '60', value: '60号'},
    {key: '80', value: '80号'},
    {key: '100', value: '100号'},
    {key: '120', value: '120号'},
    {key: '160', value: '160号'},
    {key: '200', value: '200号'},
]
export const shangxiaData = Array.from(new Array(20), (val, index) => {
    return {key: (index+1) * 1, value: (index+1) * 1};
});
export const zuoyouData = Array.from(new Array(20), (val, index) => {
    return {key: (index+1) * 0.5, value: (index+1) * 0.5};
});
